
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPanelItemButtonDialog extends Serenity.Extensions.GridEditorDialog<PsPanelItemButtonRow> {
        protected getFormKey() { return PsPanelItemButtonForm.formKey; }
        // protected getIdProperty() { return PsPanelItemButtonRow.idProperty; }
        protected getLocalTextPrefix() { return PsPanelItemButtonRow.localTextPrefix; }
        // protected getNameProperty() { return PsPanelItemButtonRow.nameProperty; }
        // protected getService() { return PsPanelItemButtonService.baseUrl; }
        // protected getDeletePermission() { return PsPanelItemButtonRow.deletePermission; }
        // protected getInsertPermission() { return PsPanelItemButtonRow.insertPermission; }
        // protected getUpdatePermission() { return PsPanelItemButtonRow.updatePermission; }

        protected form = new PsPanelItemButtonForm(this.idPrefix);

        constructor(container: JQuery) {
            super(container);

            this.form.LinkCodeFg.changeSelect2(e => {
                var tx = Q.toId(this.form.LinkCodeFg.value);
                if (!Q.isEmptyOrNull(tx)) {

                    this.form.LinkCode.value = null;
                    this.form.LinkCode.myId = tx;
                    this.form.LinkCode.updateItems();

                    if (this.form.LinkCode.items && this.form.LinkCode.items.length > 0) {
                        //Serenity.EditorUtils.setValue(this.form.LinkCode, this.form.LinkCode.items[0].id);
                    }
                }
            });

            this.form.LinkCode.changeSelect2(e => {
                var tx : string =this.form.LinkCode.value;
                if (!Q.isEmptyOrNull(tx)) {
                    if (this.form.LinkCodeFg.value == "1") {
                        console.log()
                        let x = Q.tryFirst(Product.CsPluRow.getLookup().items, x => x.PluCode == tx)
                        this.form.ItemButtonLabel.value = x.PluShortDesc;
                    } else {
                        let x = Q.tryFirst(Product.CsStyleRow.getLookup().items, x => x.StyleId == tx);
                        this.form.ItemButtonLabel.value = x.StyleName;
                    }
                }

                let vp = window.location.href.replace("#", "")
                    console.log(
                        window.location.href + "href "
                        + window.location.host + "host "
                        + window.location.hostname + "hostname "
                        + window.location.origin + "origin "
                        + window.location.pathname + "pathname "
                        + window.location.port + "port "
                        + window.location.protocol + "protocol "
                        + window.location.search + "search ")
                    let ap = vp.replace("/InitialData/PsPanelItemButton", "")


                    // console.log(window.location.host+"/uplaod/"+this.form.ItemButtonLabel.value)
                    this.form.UrlUpload.value = window.location.origin+"/upload/";


            });

            // this.form.BackImageUpload.changeSelect2(e => {
            //     var tx = Q.toId(this.form.BackImageUpload.value);
            //     if (!Q.isEmptyOrNull(tx)) {

            //         this.form.ItemButtonImage.value = window.location.origin+"/upload/"+tx;

                    


            //     }
            // });





        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if(this.isNew() ){
            console.log(this.form.LinkCodeFg.value)
            let x = "1";
            if (this.form.LinkCodeFg.value == null || this.form.LinkCodeFg.value == "1") {
                x = "1";

            } else {
                x = "2";
            }

            this.form.LinkCode.myId = x;
            this.form.LinkCode.updateItems();
            if (this.form.LinkCode.items && this.form.LinkCode.items.length > 0) {
                // Serenity.EditorUtils.setValue(this.form.LinkCode, this.form.LinkCode.items[0].id);
            }}

            if(this.isNew() || this.form.ItemButtonId.value == null){
                GeniuzPOS.InitialData.PsPanelItemButtonService.GetNextNumber({                   
                }, response => {
                    console.log(response.Serial)
                    this.form.ItemButtonId.value = Number(response.Serial);
                });
            }

            // console.log(window.location.host+"/uplaod/"+this.form.ProdImageLink.value)           

        }


    }
}